(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["csl-authorized-dealer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('csl-dealer-marquee')){customElements.define('csl-dealer-marquee',class extends HTMLElement{connectedCallback(){this.toggle=()=>{const paused=this.hasAttribute('data-paused');this.toggleAttribute('data-paused',!paused);this.querySelector('button').setAttribute('aria-pressed',String(!paused))};this.querySelector('button').addEventListener('click',this.toggle)}disconnectedCallback(){this.querySelector('button').removeEventListener('click',this.toggle)}})}
  } catch(e) { console.error(e); }
})();

})();
